import { useContext } from 'react';
import { useQuery } from 'react-query';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { brandKeys } from '../../cache-keys/brandKeys';
import { brand_api } from '@axo/shared/data-access/api';
import { MarketCountryCode } from '@axo/shared/types';

export function useBrands(marketCountry: MarketCountryCode) {
  const api = useAPI();

  const ctx = useContext(DataAccessContext);
  const token = ctx?.state?.user?.token ?? '';

  return useQuery({
    queryKey: brandKeys.allBrands(marketCountry),
    queryFn: () => brand_api.getBrands(api)({ marketCountry }),
    enabled: token.length > 0 && Boolean(marketCountry),
  });
}
